import { render, staticRenderFns } from "./CmgVerificationSystemErrorModal.vue?vue&type=template&id=685aa348&scoped=true&lang=pug"
import script from "./cmg-verification-system-error-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-verification-system-error-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgVerificationSystemErrorModal.vue?vue&type=style&index=0&id=685aa348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685aa348",
  null
  
)

export default component.exports